// EVES-5262: changes of function SessionIdentifierCell
import { CellSessionIdentifier } from "@/common/components/organisms/table/dataTableCells";
import { getSessionIdentifierBadgeProps } from "@/modules/sessions/shared/sessionIdentifier";
import { useTranslation } from "react-i18next";

const SessionIdentifierCell = (row: any) => {
  const { t: translate } = useTranslation();
  const badge = getSessionIdentifierBadgeProps(row?.identifier, translate);

  return <CellSessionIdentifier row={row} badgeProps={badge} />;
};

export default SessionIdentifierCell;
